import SubscribeForm from "@/components/feature/SubscribeForm";
import { siteInfo } from "@/mocks/site";

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="scroll-mt-24 bg-primary-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid items-center gap-10 rounded-lg border border-primary-100 bg-background-50 p-7 md:p-10 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-primary-400"></span>
              事件更新订阅
            </p>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              有新的事件复盘，第一时间告诉你
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-7 text-foreground-600">
              订阅后，每当有重点事件完成复盘、或旧事件出现后续进展时，我们会把更新摘要发到你的邮箱。也欢迎通过邮件提供线索，我们会核实后决定是否跟进。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-secondary-600"></i>
                仅发送事件更新
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-secondary-600"></i>
                随时可以退订
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-secondary-600"></i>
                {siteInfo.updateFrequency}
              </span>
            </div>
          </div>
          <div className="lg:col-span-6">
            <SubscribeForm />
          </div>
        </div>
      </div>
    </section>
  );
}